<template>
  <div @keyup.enter="validarEmail()">
    <TemplateCambios>
      <div class="panel pure-form">
        <div class="cabecera">
          Cambiar correo electrónico
        </div>

        <div class="texto">
          Indícanos tu nuevo correo electrónico
        </div>

        <div>
          <input
            id="nuevoEmail"
            v-model.trim="nuevoEmail"
            type="email"
            class="pure-input"
            placeholder="Escribe tu e-mail"
            required
            @keydown="errorEmail = null"
          />
        </div>
        <div v-if="errorEmail" class="noValido">{{ errorEmail }}</div>
        <br />
        <br />
        <button class="pure-button boton" @click="validarEmail()">
          Continuar
        </button>
      </div>
    </TemplateCambios>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nuevoEmail: "",
      errorEmail: ""
    };
  },

  computed: {},

  methods: {
    validarEmail() {
      console.log("Validar email");
      let expresionRegular = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      this.errorEmail = "";

      if (this.nuevoEmail.length < 1) {
        this.errorEmail = "Escriba un e-mail";
        return;
      }

      if (!expresionRegular.test(this.nuevoEmail)) {
        this.errorEmail = "Email incorrecto";
        return;
      }

      this.$store.dispatch("setNuevoEmail", this.nuevoEmail);
      this.$emit("siguiente");
    }
  }
};
</script>

<style scoped>
input {
  width: 100%;
  min-width: 15rem;
}
</style>
